import { NgClass } from '@angular/common';
import { Component, forwardRef, model } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'input-toggle',
  imports: [
    NgClass,
    ReactiveFormsModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputToggleComponent),
      multi: true
    }
  ],
  templateUrl: './input-toggle.component.html',
  styleUrl: './input-toggle.component.scss',
})

export class InputToggleComponent implements ControlValueAccessor {
  checked = model<boolean>(false);
  disabled = model<boolean>(false);

  // control value accessor functions
  private onChange = (_: any) => {};
  private onTouched = () => {};

  writeValue(value: boolean): void {
    this.checked.set(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  toggle() {
    if (this.disabled()) return;

    const newValue = !this.checked();
    this.checked.set(newValue);

    this.onChange(newValue);
    this.onTouched();
  }
}
